import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  addGreeting as addGreetingAction,
  publishGreeting as publishGreetingAction
} from "components/Pages/Settings/SettingsGreetings/actions";
import { BaseGreeting } from "components/Pages/Settings/SettingsGreetings/reducer";
import SvgIcon from "components/Common/SvgIcon";
import Button from "components/Common/Button";
import classNames from "classnames";
import colors from "stylesheets/utilities/colors.scss";

class GreetingFooter extends PureComponent {
  /**
   * @returns {ReactComponent}
   */
  render() {
    const {
      index, publishGreeting, addGreeting, greetings, getValue
    } = this.props;

    return (
      <div
        className={classNames(
          "Modal__bottom", {
            "Greeting__footer": getValue("paths").size === 0,
            "Greeting__save-label": getValue("paths").size !== 0
          }
        )}
      >
        {getValue("paths").size === 0 && (
          <div className="Greeting__save-label__url-warning">
            <SvgIcon
              icon="Warning"
              customClassName="Greeting__save-label__url-warning__svg"
              fillColor={colors.colorUIWarn}
            />
            <span className="Greeting__save-label__url-warning__description">
              Add at least 1 Path before publishing
            </span>
          </div>
        )}
        <div className="Greeting__save-label">
          <Button
            onClick={() => {
              if (index) {
                publishGreeting(greetings.get(index));
              } else {
                addGreeting(greetings.get(0));
              }
            }}
            customClassName="Greeting__save-label__save-button"
            title="Publish"
            text="Publish"
            size="big"
            icon="Upload"
            disabled={
              !getValue("isDirty") || (
                getValue("invalidFields").size > 0 && (
                  getValue("invalidFields").size >= 1
                )
              )
            }
          />
        </div>
      </div>
    );
  }
}

GreetingFooter.propTypes = {
  greetings: ImmutablePropTypes.listOf(PropTypes.instanceOf(BaseGreeting)).isRequired,
  getValue: PropTypes.func.isRequired,
  addGreeting: PropTypes.func.isRequired,
  publishGreeting: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};

function mapState(state) {
  return {
    greetings: state.greetings
  };
}

function mapDispatch(dispatch) {
  return bindActionCreators({
    addGreeting: addGreetingAction,
    publishGreeting: publishGreetingAction
  }, dispatch);
}

const Connector = connect(mapState, mapDispatch)(GreetingFooter);

export default Connector;
export { GreetingFooter };
